import { render, staticRenderFns } from "./default.vue?vue&type=template&id=2e2c5c54&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutHeader: require('/home/ubuntu/covert-ai-main/nuxt/components/layout/header.vue').default,LayoutFooter: require('/home/ubuntu/covert-ai-main/nuxt/components/layout/footer.vue').default,LayoutAssets: require('/home/ubuntu/covert-ai-main/nuxt/components/layout/assets.vue').default})
